import { getLocalizedString } from '../../utils/i18n-utils';
import Link from '../common/Link';
import MutedText from '../common/MutedText';
import ProxyButton from '../common/ProxyButton';

const getSameDeviceInstructions = (oktaVerifyInfoListItems: JQuery<HTMLElement>) => {
  const sameDeviceSetupElement = oktaVerifyInfoListItems.eq(1);
  const sameDeviceSetupDescription = sameDeviceSetupElement.text();
  const sameDeviceSetupBoldDescription = sameDeviceSetupElement.find('.semi-strong').text();
  return (
    <div className='fe_u_margin--bottom-large fe_u_margin--top-medium'>
      <MutedText className='okta-verify-setup-instructions-item' text={sameDeviceSetupDescription?.split(sameDeviceSetupBoldDescription)[0]} />
      <MutedText className='fe_u_font-weight--bold okta-verify-setup-instructions-item' text={getLocalizedString('oie.enroll.okta_verify.setup.text')} />
      <MutedText className='okta-verify-setup-instructions-item' text='.' />
    </div>
  );
};

const getDifferentDeviceInstructions = (oktaVerifyInfoListItems: JQuery<HTMLElement>) => {
  const differentDeviceSetupElement = oktaVerifyInfoListItems.eq(3);
  const differentDeviceText = differentDeviceSetupElement.text();
  const differentDeviceTextLink = differentDeviceSetupElement.find('.orOnMobileLink');
  const differentDeviceTextLinkText = differentDeviceTextLink.text();
  const oktaSetupButton = oktaVerifyInfoListItems.eq(2).find('a');
  return (
    <>
      <ProxyButton oktaButton={oktaSetupButton} variant='primary' fullWidth onClick={() => oktaSetupButton[0].click()} suppressOktaClick />
      <div className='fe_u_margin--top-large fe_u_margin--bottom-large'>
        <MutedText className='okta-verify-setup-instructions-item' text={differentDeviceText.split(differentDeviceTextLinkText)[0]} />
        <Link className='okta-verify-setup-instructions-item' onClick={() => differentDeviceTextLink[0].click()} text={differentDeviceTextLinkText} />
      </div>
    </>
  );
};

export default function OktaVerifyMobileSetupInstructions({ oktaComponent }: { oktaComponent: JQuery<HTMLElement> }) {
  const explanation = oktaComponent.find('.explanation').text();
  const oktaVerifyInfoListItems = oktaComponent.find('.ov-info').find('li');
  const appDownloadInstructions = oktaVerifyInfoListItems.eq(0).find('a');

  return (
    <div className='fe_u_text-align--center'>
      <MutedText text={explanation} />
      <Link className={`${appDownloadInstructions.attr('class')} okta-verify-setup-app-logo-item`} onClick={() => appDownloadInstructions[0].click()} />
      {getSameDeviceInstructions(oktaVerifyInfoListItems)}
      {getDifferentDeviceInstructions(oktaVerifyInfoListItems)}
    </div>
  );
}
